module.exports = __webpack_public_path__ + "images/icons/icon-security-827b6ce9.svg";